// removed by extract-text-webpack-plugin
module.exports = {"title":"_3u4uAo7Ux6Tdlh26mzPJ3w","subTitle":"_1yBdH3YxgPjb_orTUMf93P","row":"gjnppgty_BQ1-tH2nmdyE","buttonLoadMore":"_3zu1oPa2Vdl3vBDxBo7aO2","spinner":"_2RtTPY6lR5bePBCodxda0m","searchField":"_25nKCEOajRYJNddkWVDnTg","filters":"_3GqR53R-Nxdl4Hm_19RlPl","filter":"_2va7SPdC61C_sn9bwD45is","label":"Oq3X9vKYD-S2IJwu0Ki9V","item":"Qr73wK7HgPu9nmKIb2q7J","table":"_1K8Kb8XkLU26JAcAbnnOpx","header":"_2irKNnoXzTT7Inh6dFRB_R"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/RawMaterials/style.scss
// module id = 1246
// module chunks = 0